import { useCallback } from 'react';
import { useForm } from 'react-hook-form';
import { changeComment } from '../../../api/order/changeComment';
import { Order } from '../../../apiTypes';
import EditModal from '../../../components/EditModal';
import FormTextField from '../../../components/forms/FormTextField';
import { t } from '../../../constants/translations';
import { useAdmin } from '../../../contexts/admin.context';
import { useCafe } from '../../../contexts/cafe.context';
import { useLocale } from '../../../contexts/locale.context';

type Props = {
  order: DbDocument<Order>;
  onClose: () => void;
};

const EditCommentModal = ({ order, onClose }: Props) => {
  const { lang } = useLocale();
  const { worker } = useCafe();
  const { cafeSlug } = useAdmin();
  const form = useForm<Order>({ defaultValues: order });

  const handleSubmit = useCallback(
    (values: Order) => {
      if (worker) {
        changeComment({ order, cafeSlug, worker, comment: values.comment || '' });
        onClose();
      }
    },
    [cafeSlug, onClose, order, worker]
  );

  return (
    <EditModal<Order>
      form={form}
      open
      title={t.comment_for_order[lang]}
      onClose={onClose}
      submitButton={t.save_changes[lang]}
      submitButtonProps={{ disabled: !form.formState.isDirty }}
      onSubmit={handleSubmit}
      size="xs"
    >
      <FormTextField name="comment" fullWidth multiline label={t.comment[lang]} />
    </EditModal>
  );
};

export default EditCommentModal;
